import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { monthNames } from '../../constants';
import { DataNotFound } from '../DataNotFound';
import { postAsync } from '../helper/axiosHelper';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { HeadingSection } from '../elements/headingSection';
import LoadingAnimation from '../LoadingAnimation';
const ProjectCards = () => {
  const isActive = useSelector((state) => state.toggle.isActive);
  const [apiData, setApiData] = useState([]);
  const [pageloading, setPageLoading] = useState(false);
  const [datanotfound, setDatanotfound] = useState(false);
  const [pageOptions, setPageOptions] = useState({
    pageNo: 1,
    pageSize: 10
  });
  const { t } = useTranslation();

  const getData = async () => {
    setPageLoading(true);
    await postAsync(
      `CMSPressRelease/GetlatestUserPressReleaseFilterList?page=${pageOptions.pageNo}&pageSize=${pageOptions.pageSize}`,
      {}
    )
      .then((response) => {
        const result = response?.data;
        setApiData(result);
        setPageLoading(false);
        if (response?.statusCode == 204) {
          setDatanotfound(true);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    localStorage.setItem('isHome', true);
    getData();
  }, []);

  return (
    <>
      <div>
        <HeadingSection headingStyle={'text-black'} title="Latest Development" />

        {apiData?.length > 0 && (
          <div className="row px-4 sm:px-5 md:px-5 lg:px-5  justify-center">
            {apiData?.map((data, index) => {
              const splitdate = data?.date?.split('/');

              var dates = `${splitdate[1]}/${splitdate[0]}/${splitdate[2]}`;

              var date = new Date(dates);
              var month = monthNames[date.getMonth()];

              return (
                // <div className='flex flex-row justify-center bg-gray-900'>
                <div
                  key={index}
                  data-aos="zoom-in"
                  data-aos-once="true"
                  className="bg-white border m-1 w-96 my-3 border-gray-200 rounded-3xl shadow  px-3">
                  <Link
                    data-aos="zoom-in"
                    data-aos-once="true"
                    key={index}
                    to={`/PressReleaseDetail/${data?.pressReleaseID}`}>
                    <div className="flex flex-col pb-10 pt-6  lg:pt-6 lg:py-10 ">
                      <img
                        src={`data:image/jpeg;base64,${data?.doc}`}
                        className="mx-auto rounded-t-3xl h-40 w-full"
                      />
                      <div className="h-20 w-20 mb-3 -mt-12 rounded-full shadow-md bg-customorange text-white text-center font-semibold flex flex-col items-center justify-center">
                        <p className="leading-tight text-xl">
                          {splitdate[0]}
                          <br />
                        </p>
                        <p className="text-sm">{t(month)}</p>
                      </div>

                      {/* <div>
                          <h3 className="capitalize text-center w-full  text-customgreen lg:text-lg mb-1 font-semibold">
                            {isActive
                              ? data?.title.length > 20
                                ? `${data?.title.slice(0, 20)}...`
                                : data?.title
                              : data?.titleEn.length > 20
                                ? `${data.titleEn.slice(0, 20)}...`
                                : data.titleEn}
                          </h3>
                        </div> */}
                      <div>
                        <OverlayTrigger
                          placement="bottom"
                          overlay={
                            <Tooltip id={`tooltip-${index}`} className="custom-tooltip">
                              {isActive ? data?.title : data?.titleEn}
                            </Tooltip>
                          }>
                          <h3 className="capitalize text-center w-full text-customgreen lg:text-lg mb-1 font-semibold">
                            {isActive
                              ? data?.title.length > 20
                                ? `${data?.title.slice(0, 20)}...`
                                : data?.title
                              : data?.titleEn.length > 20
                                ? `${data.titleEn.slice(0, 20)}...`
                                : data.titleEn}
                          </h3>
                        </OverlayTrigger>
                      </div>
                    </div>
                  </Link>
                </div>
              );
            })}
          </div>
        )}
      </div>
      {pageloading && (
        <LoadingAnimation
          imageStyling={''}
          styling={'flex items-center py-5 align-middle justify-center space-x-2'}
        />
      )}
      {datanotfound && <DataNotFound />}
      {/* </div> */}
    </>
  );
};

export default ProjectCards;
